import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

interface RadioButtonSelectTypeProps {
    item: string;
    value: string;
    onButtonSelect: Function;
}

export function RadioButtonSelectType({
    item,
    value,
    onButtonSelect
}: RadioButtonSelectTypeProps): React.ReactElement {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        onButtonSelect(event.target.value);
    };

    return (
        <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}>
            <FormControlLabel
                value={value}
                control={
                    <Radio
                        checked={value === item}
                        onChange={handleChange}
                        value={item}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': item }}
                        sx={{
                            color: '#394A35',
                            '&.Mui-checked': {
                                color: '#394A35'
                            }
                        }}
                    />
                }
                label={item}
            />
        </RadioGroup>
    );
}
